import React from 'react';

export default function Pagination({ currentPage, totalPages, paginate }) {
  const buttonClass = "flex items-center px-4 py-2 text-sm font-medium text-muted-foreground bg-background-soft rounded-lg hover:bg-surface-hover hover:text-foreground disabled:opacity-50 disabled:cursor-not-allowed border border-border/60 hover:border-border transition-all duration-200";
  const activeClass = "bg-accent text-accent-foreground border-accent hover:bg-accent-hover";

  // Determine the range of page numbers to display
  const getPageNumbers = () => {
    const delta = 2; // How many pages to show around the current page
    const left = currentPage - delta;
    const right = currentPage + delta + 1;
    const range = [];
    const rangeWithDots = [];

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= left && i < right)) {
        range.push(i);
      }
    }

    let l;
    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="flex justify-center items-center gap-2 mt-8">
      {/* First Button */}
      <button
        onClick={() => paginate(1)}
        disabled={currentPage === 1}
        className={`${buttonClass} px-3`}
        aria-label="Go to first page"
      >
        &laquo;
      </button>

      {/* Previous Button */}
      <button
        onClick={() => paginate(currentPage - 1)}
        disabled={currentPage === 1}
        className={buttonClass}
      >
        Previous
      </button>

      {/* Page Numbers */}
      <div className="flex items-center gap-1.5">
        {pageNumbers.map((number, index) => (
          number === '...' ? (
            <span key={`dots-${index}`} className="px-2 py-2 text-sm text-muted-foreground">...</span>
          ) : (
            <button
              key={number}
              onClick={() => paginate(number)}
              className={`${buttonClass} px-3.5 ${currentPage === number ? activeClass : ''}`}
              aria-label={`Go to page ${number}`}
              aria-current={currentPage === number ? 'page' : undefined}
            >
              {number}
            </button>
          )
        ))}
      </div>

      {/* Next Button */}
      <button
        onClick={() => paginate(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={buttonClass}
      >
        Next
      </button>

      {/* Last Button */}
      <button
        onClick={() => paginate(totalPages)}
        disabled={currentPage === totalPages}
        className={`${buttonClass} px-3`}
        aria-label="Go to last page"
      >
        &raquo;
      </button>
    </div>
  );
} 